
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataLink } from './data-link';
import { Apollo } from 'apollo-angular';

const createDataLinkMutation = require('./gql/create-data-link.mutation.gql');
const updateDataLinkMutation = require('./gql/update-data-link.mutation.gql');
const deleteDataLinkMutation = require('./gql/delete-data-link.mutation.gql');

/**
 * Service to manage data links
 */
@Injectable()
export class DataLinkService {

  constructor(private apollo: Apollo) { }

  create(dossier_id: string, link: DataLink): Observable<DataLink> {
    return this.apollo
      .mutate({
        mutation: createDataLinkMutation,
        variables: {
          input: link.toCreateDataLinkInput(dossier_id)
        }
      }).pipe(
      map(result => new DataLink(result.data['createDataLink'])));
  }

  update(id: string, link: DataLink): Observable<DataLink> {
    return this.apollo
      .mutate({
        mutation: updateDataLinkMutation,
        variables: {
          id,
          input: link.toUpdateDataLinkInput()
        }
      }).pipe(
      map(result => new DataLink(result.data['updateDataLink'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteDataLinkMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteDataLink']));
  }
}